import React from 'react'

import { Text, View } from '@react-pdf/renderer'
import {
  PerformanceProcessPrintableAgreementSignatureAccessFragment,
  PerformanceProcessPrintableAgreementSignaturesFragment,
} from 'generated/resources/graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { Section, SectionTitle } from './_Blocks'

function formatDate(date: string) {
  return dateToString(moment(date), 'ui_dmy_long')
}

const Signature: React.FC<{
  signer: PerformanceProcessPrintableAgreementSignatureAccessFragment
  signedAt: string
}> = ({ signer, signedAt }) => (
  <View
    style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Text style={{ fontWeight: 'bold' }}>{signer?.fullName}</Text>
    <Text>{signer?.employee?.referenceContract?.jobTitle}</Text>
    <Text>{formatDate(signedAt)}</Text>
  </View>
)

export const Signatures: React.FC<{
  agreement: PerformanceProcessPrintableAgreementSignaturesFragment
}> = ({ agreement }) => {
  return (
    <Section>
      <SectionTitle>
        {i18n.t('performance_process.agreements.printable_pdf.agreed_by')}
      </SectionTitle>
      <View style={{ flexDirection: 'row', marginVertical: '20' }}>
        {agreement?.signer && agreement.managerSignedAt && (
          <Signature signer={agreement.signer} signedAt={agreement.managerSignedAt} />
        )}
        {agreement?.target?.access && agreement.targetSignedAt && (
          <Signature signer={agreement.target.access} signedAt={agreement.targetSignedAt} />
        )}
      </View>
    </Section>
  )
}
